import { NewUserErrorFormI, NewUserFormI } from "./types"
import { isValidEmail } from "../../util/users"
import { inviteUserErrorMessages } from "../../util/errorMessages"
import { LabelValueOptionType } from "../../types/commonTypes"
import { objectHasDefinedFields } from "../../util/objects/objects"
import { StringValidation } from "../../util/validation/string"
import { Sanitize } from "../../util/sanitize/sanitize"

const disableSubmitInviteUser = (newUserState: NewUserFormI) => {
    const errors = validateInviteUserInputData(newUserState)
    const hasErrors = objectHasDefinedFields(errors)
    return hasErrors
}

const validateInviteUserInputData = (
    newUserState: NewUserFormI
): NewUserErrorFormI => {
    const newErrorState: NewUserErrorFormI = {
        email: undefined,
        firstName: undefined,
        lastName: undefined,
        organization: undefined,
    }

    const { email, firstName, lastName, organization } = newUserState

    if (StringValidation.isEmpty(email) || !isValidEmail(email)) {
        newErrorState.email = inviteUserErrorMessages.newUserErrorState.email
    }

    if (StringValidation.isEmpty(firstName)) {
        newErrorState.firstName =
            inviteUserErrorMessages.newUserErrorState.firstName
    }

    if (StringValidation.isEmpty(lastName)) {
        newErrorState.lastName =
            inviteUserErrorMessages.newUserErrorState.lastName
    }

    if (organization === undefined) {
        newErrorState.organization =
            inviteUserErrorMessages.newUserErrorState.organization
    }

    return newErrorState
}

// Per business logic && request from the team:
// if there is only one organization the dropdown should be populated with that organization
// otherwise the dropdown should be empty to prevent the accidental assignment of the user to the wrong organization. (We want the user to manually select the organization)
const getInviteUserFormInitialOrgState = (
    organizationAndDescendants: LabelValueOptionType[]
) => {
    if (organizationAndDescendants.length === 1) {
        return organizationAndDescendants[0]
    }
    return undefined
}

const sanitizeInviteUserInputData = (form: NewUserFormI): NewUserFormI => {
    return {
        ...form,
        email: Sanitize.string(form.email),
        firstName: Sanitize.string(form.firstName),
        lastName: Sanitize.string(form.lastName),
    }
}

export {
    validateInviteUserInputData,
    disableSubmitInviteUser,
    getInviteUserFormInitialOrgState,
    sanitizeInviteUserInputData,
}
